import {
	PayPalCreateBillingAgreementRequest,
	PayPalCreateBillingAgreementResponse,
	PayPalDeleteBillingAgreementResponse,
	PayPalExecuteBillingAgreementRequest,
	PayPalExecuteBillingAgreementResponse,
	PayPalOrderCreateAndCaptureRequest,
	PayPalOrderCreateAndCaptureResponse,
	PayPalSearchBillingAgreementRequest,
	PayPalSearchBillingAgreementResponse,
	PayPalSetMsiDetailsRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class PayPal<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags PayPal
	 * @name CreateBillingAgreement
	 * @request POST:/store/{storeId}/hdm/paypal/billingAgreement/createBillingAgreement
	 * @response `200` `PayPalCreateBillingAgreementResponse`
	 */
	createBillingAgreement = (
		storeId: string,
		data: PayPalCreateBillingAgreementRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['createBillingAgreement'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/paypal/billingAgreement/createBillingAgreement`,
				params: _params,
				body: data,
				methodName: 'createBillingAgreement',
			};
			logger.trace(traceData);
		}
		return this.http.request<PayPalCreateBillingAgreementResponse, any>({
			path: `/store/${storeId}/hdm/paypal/billingAgreement/createBillingAgreement`,
			method: 'POST',
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags PayPal
	 * @name ExecuteBillingAgreement
	 * @request POST:/store/{storeId}/hdm/paypal/billingAgreement/executeBillingAgreement
	 * @response `200` `PayPalExecuteBillingAgreementResponse`
	 */
	executeBillingAgreement = (
		storeId: string,
		data: PayPalExecuteBillingAgreementRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['executeBillingAgreement'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/paypal/billingAgreement/executeBillingAgreement`,
				params: _params,
				body: data,
				methodName: 'executeBillingAgreement',
			};
			logger.trace(traceData);
		}
		return this.http.request<PayPalExecuteBillingAgreementResponse, any>({
			path: `/store/${storeId}/hdm/paypal/billingAgreement/executeBillingAgreement`,
			method: 'POST',
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags PayPal
	 * @name DeleteBillingAgreement
	 * @request DELETE:/store/{storeId}/hdm/paypal/billingAgreement/deleteBillingAgreement
	 * @response `200` `PayPalDeleteBillingAgreementResponse`
	 */
	deleteBillingAgreement = (storeId: string, params: RequestParams = {}) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['deleteBillingAgreement'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/paypal/billingAgreement/deleteBillingAgreement`,
				params: _params,
				methodName: 'deleteBillingAgreement',
			};
			logger.trace(traceData);
		}
		return this.http.request<PayPalDeleteBillingAgreementResponse, any>({
			path: `/store/${storeId}/hdm/paypal/billingAgreement/deleteBillingAgreement`,
			method: 'DELETE',
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags PayPal
	 * @name SearchBillingAgreement
	 * @request POST:/store/{storeId}/hdm/paypal/checkout/searchBillingAgreement
	 * @response `200` `PayPalSearchBillingAgreementResponse`
	 */
	searchBillingAgreement = (
		storeId: string,
		data: PayPalSearchBillingAgreementRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['searchBillingAgreement'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/paypal/checkout/searchBillingAgreement`,
				params: _params,
				body: data,
				methodName: 'searchBillingAgreement',
			};
			logger.trace(traceData);
		}
		return this.http.request<PayPalSearchBillingAgreementResponse, any>({
			path: `/store/${storeId}/hdm/paypal/checkout/searchBillingAgreement`,
			method: 'POST',
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags PayPal
	 * @name OrderCreateAndCapture
	 * @request POST:/store/{storeId}/hdm/paypal/checkout/orderCreateAndCapture
	 * @response `200` `PayPalOrderCreateAndCaptureResponse`
	 */
	orderCreateAndCapture = (
		storeId: string,
		data: PayPalOrderCreateAndCaptureRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['orderCreateAndCapture'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/paypal/checkout/orderCreateAndCapture`,
				params: _params,
				body: data,
				methodName: 'orderCreateAndCapture',
			};
			logger.trace(traceData);
		}
		return this.http.request<PayPalOrderCreateAndCaptureResponse, any>({
			path: `/store/${storeId}/hdm/paypal/checkout/orderCreateAndCapture`,
			method: 'POST',
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags PayPal
	 * @name SetMsiDetails
	 * @request POST:/store/{storeId}/hdm/paypal/checkout/setMsiDetails
	 */
	setMsiDetails = (
		storeId: string,
		data: PayPalSetMsiDetailsRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['setMsiDetails'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/paypal/checkout/setMsiDetails`,
				params: _params,
				body: data,
				methodName: 'setMsiDetails',
			};
			logger.trace(traceData);
		}
		return this.http.request<any, any>({
			path: `/store/${storeId}/hdm/paypal/checkout/setMsiDetails`,
			method: 'POST',
			body: data,
			type: params.type ?? ContentType.Json,
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
